import { createContext } from "react";
import type { ResolvedTheme, ThemePreference } from "./theme";

export interface ThemeContextValue {
  /** What the visitor chose: system, light or dark. */
  preference: ThemePreference;
  /** What is currently painted, with `system` already resolved. */
  resolved: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
